import { Box, BoxProps } from "@mui/material";
import { forwardRef } from "react";

export type SHBoxProps = BoxProps;
export const SHBox = forwardRef(
  (props: SHBoxProps, ref): JSX.Element => <Box {...props} ref={ref} />,
);
